/**
 *
 */
export enum ActualExpectedGraphType {
    POWER = "power",
    ENERGY = "energy",
    PUE = "PUE",
    WEATHER = "weather"
}